/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Space_File_Delete_WarningInputs */



/**
* | output |
* | --- |
* | "The file and its earlier versions are deleted permanently. This cannot be undone." |
*
* @param {Chat_Space_File_Delete_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_delete_warning = /** @type {((inputs?: Chat_Space_File_Delete_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_Delete_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei und ihre früheren Fassungen werden endgültig gelöscht. Das lässt sich nicht rückgängig machen.")
	return /** @type {LocalizedString} */ ("The file and its earlier versions are deleted permanently. This cannot be undone.")
});